import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ThresholdIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 29 10"
    >
      <g transform="translate(1 1)">
        <line
          x2="27"
          transform="translate(0 4)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1408,9.5c3.372,0,3.372,8,6.743,8s3.375-8,6.749-8,3.377,8,6.754,8,3.377-8,6.754-8"
          transform="translate(-1408 -9.5)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
